import React from "react";
import { useTranslation } from "react-i18next";
import TrashIcon from "../icons/trashR.svg";
import EditIcon from "../icons/editB.svg";

const VehicleRow = ({ vehicle, onDelete, onEdit }) => {
  const { t } = useTranslation();

  const L = {
    type: t("rows.vehicleType"),
    brand: t("rows.brand"),
    color: t("rows.color"),
    plate: t("rows.immatriculation"),
    vin: t("rows.vinNumber"),
    fuelType: t("rows.fuelType"),
    model: t("rows.model"),
  };

  return (
    <div className="grid grid-cols-[12.5%_12.5%_12.5%_12.5%_12.5%_12.5%_12.5%_12.5%] items-center bg-white p-6 rounded-[12px] shadow-[0px_6px_26px_rgba(98,107,125,0.07)]">
      {/* TYPE */}
      <div>
        <p className="text-[#707070] text-[12px] font-semibold uppercase">
          {L.type}
        </p>
        <p className="text-[#043F88] text-[18px] font-semibold break-words">
          {t(`filters.vehicles.${vehicle?.type}`) || "—"}
        </p>
      </div>

      {/* BRAND */}
      <div>
        <p className="text-[#707070] text-[12px] font-semibold uppercase">
          {L.brand}
        </p>
        <p className="text-[#043F88] text-[18px] font-semibold break-words">
          {vehicle?.brand?.name || vehicle?.brandMake || "—"}
        </p>
      </div>

      {/* COLOR */}
      <div>
        <p className="text-[#707070] text-[12px] font-semibold uppercase">
          {L.color}
        </p>
        <p className="text-[#043F88] text-[18px] font-semibold break-words">
          {vehicle?.color || "—"}
        </p>
      </div>

      {/* MODEL */}
      <div>
        <p className="text-[#707070] text-[12px] font-semibold uppercase">
          {L.model}
        </p>
        <p className="text-[#043F88] text-[18px] font-semibold break-words">
          {vehicle?.model || "—"}
        </p>
      </div>

      {/* FUEL TYPE */}
      <div>
        <p className="text-[#707070] text-[12px] font-semibold uppercase">
          {L.fuelType}
        </p>
        <p className="text-[#043F88] text-[18px] font-semibold break-words">
          {t(`filters.vehicles.${vehicle?.fuelType}`) || "—"}
        </p>
      </div>

      {/* IMMATRICULATION */}
      <div>
        <p className="text-[#707070] text-[12px] font-semibold uppercase">
          {L.plate}
        </p>
        <p className="text-[#043F88] text-[18px] font-semibold break-words">
          {vehicle?.immatriculationNumber || "—"}
        </p>
      </div>

      {/* VIN */}
      <div>
        <p className="text-[#707070] text-[12px] font-semibold uppercase">
          {L.vin}
        </p>
        <p className="text-[#043F88] text-[18px] font-semibold break-words">
          {vehicle?.vinNumber || "—"}
        </p>
      </div>

      {/* DELETE BUTTON */}
      <div className="flex justify-end gap-2">
        <button
          type="button"
          aria-label="Edit vehicle"
          onClick={() => onEdit?.(vehicle)}
          className="w-8 h-8 flex items-center justify-center bg-[#F9FAFC] rounded-[12px] border border-primary"
        >
          <img src={EditIcon} alt="" className="w-4 h-4" />
        </button>
        <button
          type="button"
          aria-label="Delete vehicle"
          onClick={() => onDelete?.(vehicle)}
          className="w-8 h-8 flex items-center justify-center bg-[#F9FAFC] rounded-[12px] border border-[#EF466F4D]"
          >
          <img src={TrashIcon} alt="" className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default VehicleRow;
